export default __webpack_public_path__ + "static/packet-size-1e012ca15566e79828d1c63dbb00f547.png";